<template lang="html">
  <header id="header">
    <div class="header-content">

      <section class="top-section" v-if="false">
        <div class="container med-container">
          <div class="row">
            <!-- <div class="col-lg col-form">
              <b-form @submit="onSubmit">
                <b-form-input
                  v-model="form.keywords"
                  type="text"
                  placeholder="SEARCH IN OUR KNOWLEDGE CENTER..."
                  size="sm"
                  required
                ></b-form-input>
                <b-button type="submit" size="sm"><i class="fas fa-search"></i></b-button>
              </b-form>
            </div> -->

            <div class="col-lg col-buttons">
              <span class="d-none d-sm-inline-block mr-2">Procesos Plasticos Inyectados S.A de C.V</span>
              <a class="d-none d-sm-inline-block whatsapp" href="tel:5213338109988"><i class="fa-solid fa-phone icon"></i> (+52) (01) 33 3810 9988</a>
              <!-- <a class="d-none d-sm-inline-block whatsapp" target="_blank" href=""><i class="fa-brands fa-whatsapp icon"></i> ATENCIÓN AL CLIENTE</a> -->
              <!-- <router-link class="d-none d-sm-inline-block ml-4" to="/cart"><i class="fa-solid fa-cart-shopping"></i> CARRITO</router-link> -->
              <!-- <router-link class="ml-lg-4 t-150 btn-special d-none d-lg-inline" to="/cart"><i class="fa-solid fa-cart-shopping icon"></i> CARRITO</router-link> -->
            </div>

            <div class="col-lg col-social-networks">
              <!-- <a class="btn-network" href="#"><i class="fab fa-google-play"></i></a>
              <a class="btn-network" href="#"><i class="fab fa-apple"></i></a> -->
              <a class="t-150 btn-network" target="_blank" href="https://www.facebook.com/ppimacetas?ref=embed_page"><i class="fa-brands fa-facebook-f"></i></a>
              <!-- <a class="t-150 btn-network" target="_blank" href="https://x.com/PpiInfo"><i class="fa-brands fa-x-twitter"></i></a> -->
              <a class="t-150 btn-network" target="_blank" href="https://www.instagram.com/procesosplasticosinyectados/"><i class="fa-brands fa-instagram"></i></a>
              <a class="t-150 btn-network" target="_blank" href="https://www.tiktok.com/@procesosplasticos?_t=ZS-8z4A9Vf0lHz&_r=1"><i class="fa-brands fa-tiktok"></i></a>
            </div>
          </div>
        </div>
      </section>

      <section class="top-section-v2">
        <div class="box-content">
          <div class="box-contact mr-3">
            <div class="bubble-contact mr-3 mr-sm-2">
              <div class="circle c1"><i class="fa-solid fa-location-dot"></i></div>
              <div class="text">Calle 10A #1795</div>
            </div>

            <div class="bubble-contact">
              <div class="circle c2"><i class="fa-solid fa-phone-volume"></i></div>
              <a class="text" href="tel:3338109988">(33) 3810 9988</a>
            </div>
          </div>

          <div class="box-networks">
            <a class="n-link fb" target="_blank" :href="$root.redes.facebook"><i class="fa-brands fa-facebook"></i></a>
            <a class="n-link" target="_blank" :href="$root.redes.instagram"><i class="fa-brands fa-instagram"></i></a>
            <a class="tiktok" target="_blank" :href="$root.redes.tiktok"><i class="fa-brands fa-tiktok"></i></a>
          </div>
        </div>
      </section>

      <section class="menu-section">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <div class="container med-container">
            <b-navbar-brand to="/">
              <img src="public/images/logo.svg">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse">
              <i class="fa-sharp fa-regular fa-bars"></i>
            </b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown right>
                  <template #button-content>
                    <span>Equipos CNC</span>
                  </template>
                  <b-dropdown-item to="/categoria" v-for="(e, eInx) in equipos" :key="'eInx-'+eInx">{{ e }}</b-dropdown-item>
                </b-nav-item-dropdown> -->

                <b-nav-item class="simple-item" to="/">Inicio</b-nav-item>
                <li class="nav-item item-simple">
                  <a class="nav-link" @click="isHActive = !isHActive">Productos <i class="fas fa-chevron-down submenu-icon"></i></a>
                </li>
                <!-- <b-nav-item class="simple-item" to="/servicios">Servicios</b-nav-item> -->
                <b-nav-item-dropdown right>
                  <!-- Using 'button-content' slot -->
                  <template #button-content>
                    <span>Servicios</span>
                  </template>
                  <b-dropdown-item to="/servicios">Nuestros servicios</b-dropdown-item>
                  <b-dropdown-item to="/servicios/diseno-de-moldes-de-inyeccion">Diseño de moldes</b-dropdown-item>
                  <b-dropdown-item to="/servicios/inyeccion-y-maquila">Inyeccion y maquila</b-dropdown-item>
                  <b-dropdown-item to="/servicios/proyectos-e-ingenieria">Proyectos e ingenieria</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item class="simple-item" to="/empresa">Empresa</b-nav-item>
                <b-nav-item class="simple-item s-item-w-icon" to="/contacto"><i class="fa-sharp fa-solid fa-envelope icon"></i> Contacto</b-nav-item>
                <b-nav-item class="simple-item s-item-w-icon" to="/blog"><i class="fa-solid fa-book icon"></i> Blog</b-nav-item>

                <!-- <b-nav-item class="icon-item" to="/contacto">
                  <i class="fas fa-envelope icon"></i> <span class="d-lg-none">Contacto</span>
                </b-nav-item> -->

                <!-- <b-nav-item class="icon-item" to="/cart">
                  <i class="fa-solid fa-cart-shopping icon"></i> <span class="d-lg-none">Carrito</span>
                </b-nav-item> -->

                <!-- <b-nav-item-dropdown class="icon-item" right>
                  <template #button-content>
                    <span>
                      <i class="fas fa-user-circle icon"></i> <span class="d-lg-none">Mi cuenta</span>
                  </span>
                  </template>
                  <b-dropdown-item to="/login">Iniciar sesión</b-dropdown-item>
                  <b-dropdown-item to="/registrarse">Registrarse</b-dropdown-item>
                </b-nav-item-dropdown> -->
              </b-navbar-nav>
            </b-collapse>
          </div>
        </b-navbar>
      </section>

      <SearchbarComponent v-if="$route.name != 'homePage'"></SearchbarComponent>
    </div>

    <!-- Productos -->
    <div class="t-250 products-menu" v-bind:class="{ active: isHActive }">
      <div class="menu-bg" @click="isHActive = false"></div>

      <div class="tablist" role="tablist">
        <div class="t-250 box-title" @click="isHActive = false">
          <h4>PRODUCTOS</h4>
          <!-- <br>
          <h5 v-on:click="$router.push('/categoria');">Categorias</h5> -->
          <!-- <i class="fas fa-chevron-left icon"></i> -->
          <i class="fas fa-chevron-square-left icon"></i>
        </div>

        <b-card no-body class="mb-1" v-for="(category, pcatIndex) in $root.menu" :key="pcatIndex">
          <b-card-header header-tag="header" role="tab">
            <div v-if="category.products" class="btn-toggle">
              <router-link :to="'/categoria/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
              <span class="fake-toggle" v-b-toggle="'accordion-'+pcatIndex"></span>
            </div>
            <router-link v-else class="btn-toggle" :to="'/categoria/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
          </b-card-header>

          <b-collapse v-if="category.products" :id="'accordion-'+pcatIndex" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="ul-sub-options">
                <li v-for="subcategory in category.products">
                  <router-link class="t-250" :to="'/producto/'+$root._converToURL(subcategory.name, subcategory.id)">{{ subcategory.name }}</router-link>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <!--  -->

    <!-- WhatsApp -->
    <a class="ic-glob-whatsapp" target="_blank" :href="'https://wa.me/'+$root.redes.whatsapp" v-if="$root.redes.whatsapp"><i class="fab fa-whatsapp"></i></a>
    <!--  -->

  </header>
</template>

<script>
import SearchbarComponent from './searchbar-component.vue';
export default {
  components: {
    SearchbarComponent
  },

  data() {
    return {
      // == Products menu ==
      isHActive: false,
      categories:[ // ** Remover el contenido de este array ejemplo al conectar para no dejar CODIGO BASURA
        // { id: 2, name: 'Macetas para cultivo', subcategories: [
        //   { id: 1, name: 'Maceta Azalea' },
        //   { id: 2, name: 'Maceta colgante' },
        // ] },
        // { id: 4, name: 'Macetas Decorativas', subcategories: [
        //   { id: 1, name: 'Macetas biodegradables' },
        //   { id: 2, name: 'Maceta tonalá' },
        //   { id: 2, name: 'Maceta venecia' },
        // ] },
        // { id: 3, name: 'Macetas Deco-Art', subcategories: [
        //   { id: 1, name: 'Serie animalitos' },
        //   { id: 2, name: 'Serie dunas' },
        //   { id: 2, name: 'Seria acuario' },
        // ] },
      ],
      // == ==

      formCatalog: {
        cat: [],
      },

      equipos: [
        'Router CNC',
      ],      
    }
  },

  methods: {
    onSubmitCatalog(event) {
      event.preventDefault();
    },
  },

  watch: {
    $route (to, from){
      // Ocultar menu cada vez que cambie la ruta
      this.isHActive = false;
    },
  },
}
</script>
